import type { IChecklistGroup, TSubtaskUpdateMethod } from '@bridebook/web/lib/checklist/types';
import { ChecklistAnalyticsActionTypes } from '@bridebook/web/lib/checklist/analytics/action-types';

export const changedMainTaskPeriodAnalytics = (group: IChecklistGroup) => ({
  type: ChecklistAnalyticsActionTypes.CHANGED_MAIN_TASK_PERIOD_ANALYTICS,
  payload: group,
});

export const updatedSubtaskAnalytics = (payload: {
  subtaskId: string;
  name?: string;
  checked: boolean;
  method: TSubtaskUpdateMethod;
}) => ({
  type: ChecklistAnalyticsActionTypes.UPDATE_SUBTASK_ANALYTICS,
  payload,
});

// A task's subtasks were shown. The id and name are for views outside the checklist page.
export const openedSubtasksViewAnalytics = (payload: { taskId?: string; taskName?: string }) => ({
  type: ChecklistAnalyticsActionTypes.SHOW_DETAILS_OPENED_ANALYTICS,
  payload,
});
